import { Injectable } from "@angular/core";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

import {
  BfxMultiBlotterService,
  SKIP_INIT_DATA_SERVICE,
} from "../../bfx-base-blotter/bfx-base-blotter.service";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { GoldenLayoutService } from "app/golden-layout/golden-layout-service";
import { GLComponentAlertStatus } from "app/golden-layout/golden-layout-component";
import { RiskTradeTableDefinitionFactory } from "../../../shared/cubiq-services/model/RiskTradeTableDefinitionFactory";
import {
  LimitRiskTradePrimaryLookupService,
  AlgoRiskTradePrimaryLookupService,
  BMRiskTradePrimaryLookupService,
} from "../../../shared/cubiq-services/lookup/model/impl/RiskTradePrimaryLookupService";
import { TradeOrderFilterType } from "app/bfx-interface-controls/helpers/TradeTypeFilterHelper";

@Injectable()
export class BfxRiskTradeBlotterService extends BfxMultiBlotterService {
  private component: any = null;

  constructor(
    public limitDataService: LimitRiskTradePrimaryLookupService,
    public algoDataService: AlgoRiskTradePrimaryLookupService,
    public bmDataService: BMRiskTradePrimaryLookupService,
    public tableDefinitionService: RiskTradeTableDefinitionFactory,
    protected goldenLayoutService: GoldenLayoutService,
  ) {
    super(SKIP_INIT_DATA_SERVICE, tableDefinitionService);

    this.createTableDefinition();
    this.primeDataService();
    this.updateFilterData();
  }

  protected subscribeToSubject(): void {
    this.limitDataService.getModelUpdateSubject().subscribe((data) => {
      this.onModelUpdate(data);
    });
    this.limitDataService.getModelDeleteSubject().subscribe((data) => {
      this.onModelDelete(data);
    });
    this.algoDataService.getModelUpdateSubject().subscribe((data) => {
      this.onModelUpdate(data);
    });
    this.algoDataService.getModelDeleteSubject().subscribe((data) => {
      this.onModelDelete(data);
    });
    this.bmDataService.getModelUpdateSubject().subscribe((data) => {
      this.onModelUpdate(data);
    });
    this.bmDataService.getModelDeleteSubject().subscribe((data) => {
      this.onModelDelete(data);
    });
  }

  runOnActiveDataService(methodName: string, ...args): Promise<PromiseSettledResult<any>[]> {
    return Promise.allSettled([
      ...[this.limitDataService[methodName](...args)],
      ...[this.algoDataService[methodName](...args)],
      ...[this.bmDataService[methodName](...args)],
    ]);
  }

  public updateFilterData(): void {
    if (this.component != null) {
      this.updateBadgeCount(this.component);
    }
  }

  public getItemCount(): number {
    return this.getRowData().filter((order: any) => {
      return (
        order.as_fv_dealStateId ===
        (CubiqTS.OrderDealState[CubiqTS.OrderDealState.ACK_TIME_OUT] ||
          CubiqTS.OrderDealState[CubiqTS.OrderDealState.NAK])
      );
    }).length;
  }

  public updateBadgeCount(component: any): void {
    this._ready.then(() => {
      if (this.component == null && component != null) {
        this.component = component;
        this.updateFilterData();
        return;
      }
      let badgeCount = this.getItemCount();
      let alertStatus = this.component.getAlertStatus();
      this.goldenLayoutService.updateBadge(component, badgeCount, alertStatus);
    });
  }
}
